import { View, Image, Text } from "react-native";
import { useTranslation } from "react-i18next";

export type errorTypes = 'no_connection' | 'no_activities' | 'forgot_activities' | 'no_activities_for_other_days' | 'no_documents' | 'no_documents_filtered' | 'no_visits' | 'no_visits_filtered';

interface MainErrorWithIconProps {
    errorType: errorTypes;
}

const MainErrorWithIcon = ({ errorType }: MainErrorWithIconProps) => {
    const { t } = useTranslation();

    const errors: Record<errorTypes, {
        image: any;
        message: { partOne?: string; partTwo?: string };
    }> = {
        no_connection: {
            image: require('@assets/images/no_connection.png'),
            message: { partOne: t('commons.connection.noConnection') }
        },
        no_activities: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partOne: t('activities.noActivities.partOne'),
                partTwo: t('activities.noActivities.partTwo')
            },
        },
        no_activities_for_other_days: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partTwo: t('activities.noActivitiesForOtherDays'),
            },
        },
        forgot_activities: {
            image: require('@assets/images/forgot_activities.png'),
            message: {
                partOne: t('activities.forgotActivities.partOne'),
                partTwo: t('activities.forgotActivities.partTwo')
            },
        },
        no_documents: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partOne: t('history.documents.emptyState')
            },
        },
        no_documents_filtered: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partOne: t('history.documents.emptyStateFiltered')
            },
        },
        no_visits: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partOne: t('history.visits.emptyState')
            },
        },
        no_visits_filtered: {
            image: require('@assets/images/no_activities.png'),
            message: {
                partOne: t('history.visits.emptyStateFiltered')
            },
        },
    }

    return (
        <View className="items-center pt-2xl" >
            <View className="flex w-full h-56 mb-6">
                <Image
                    className="w-full h-full"
                    resizeMode="contain"
                    source={errors[errorType].image}
                />
            </View>
            <View className="w-full items-center">
                {errors[errorType].message.partOne && (
                    <Text className="text-lg font-bold text-center mb-2" >
                        {errors[errorType].message.partOne}
                    </Text>
                )}
                {errors[errorType].message.partTwo && (
                    <Text className="text-lg text-center mb-2" >
                        {errors[errorType].message.partTwo}
                    </Text>
                )}
            </View>
        </View >
    );
};

export default MainErrorWithIcon;